function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7a1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7a1"] = parcelRequire;
}
parcelRequire.register("6O6f4", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4f4c4128be0896eb$export$6503ec6e8aabbaf; }, function (v) { return $4f4c4128be0896eb$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4f4c4128be0896eb$export$f7ad0328861e2f03; }, function (v) { return $4f4c4128be0896eb$export$f7ad0328861e2f03 = v; });
var $4f4c4128be0896eb$export$6503ec6e8aabbaf;
var $4f4c4128be0896eb$export$f7ad0328861e2f03;
"use strict";
var $4f4c4128be0896eb$var$mapping = {};
function $4f4c4128be0896eb$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$4f4c4128be0896eb$var$mapping[keys[i]] = pairs[keys[i]];
}
function $4f4c4128be0896eb$var$resolve(id) {
    var resolved = $4f4c4128be0896eb$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$4f4c4128be0896eb$export$6503ec6e8aabbaf = $4f4c4128be0896eb$var$register;
$4f4c4128be0896eb$export$f7ad0328861e2f03 = $4f4c4128be0896eb$var$resolve;

});

var $87a4e3d533bfdec3$exports = {};

(parcelRequire("6O6f4")).register(JSON.parse('{"6gHc5":"index.c90887b1.js","f1VEZ":"worker.ba9474a5.js","192U9":"worker.cfed56d1.js","aQYxc":"worker.29a560c5.js","8IdKL":"worker.834f3edf.js","jTa90":"worker.03c950bb.js","eKxQp":"zappar-cv.315eebda.wasm","a1a1b":"face_mesh_face_model.9f3b859a.zbin","5O01f":"face_mesh_full_head_simplified_model.caf9de0a.zbin","4XTV2":"face_tracking_model.624095d1.zbin","5K2PS":"macula.cb4c3f85.png","fnlsC":"cataracts.3e6ec60a.png","idKzf":"bluenoise.cc4847c7.png","iH9Wz":"camouflage-1.f199d488.png","9JylQ":"camouflage-2.ebc92aae.png","k5jqV":"camouflage-3.2b244d66.png","g4uRk":"camouflage-4.1f844b97.png","dZso2":"camouflage-5.142187c1.png","kzAtO":"tunnel-1.4dff8715.png","eXWaU":"tunnel-2.dcfd3fec.png","5GbAk":"tunnel-3.6ef23598.png","fjjT3":"tunnel-4.dfeacddb.png","dqYJk":"tunnel-5.66cd80c6.png","jKBTe":"glaucoma-1.938075b0.png","4CNuz":"glaucoma-2.50fa29f1.png","hLaCZ":"glaucoma-3.210b26c6.png","dCgW2":"glaucoma-4.56535b37.png","4Toe9":"glaucoma-5.e0cc49b7.png","eHwGv":"zappar-cv.1ce8bf42.wasm","5RJZY":"face_mesh_face_model.9f3b859a.zbin","j2yrH":"face_mesh_full_head_simplified_model.caf9de0a.zbin","2Pz1w":"face_tracking_model.624095d1.zbin","2TRTe":"VrControllerImage.f8d6837c.jpg","giue7":"HeadsetReferenceOnly.4b4164db.jpg","3Mf84":"CameraPopup.6c75acea.png","8NO10":"VRwarningIcon.81886fcb.svg","3ZZKc":"index.b7b3e8f1.css"}'));


//# sourceMappingURL=index.fa2a7a98.js.map
